import { render, staticRenderFns } from "./SuppList.vue?vue&type=template&id=b0137520&scoped=true&"
import script from "./SuppList.vue?vue&type=script&lang=js&"
export * from "./SuppList.vue?vue&type=script&lang=js&"
import style0 from "./SuppList.vue?vue&type=style&index=0&id=b0137520&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0137520",
  null
  
)

export default component.exports